
import { X, PanelLeftClose, PanelLeftOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
interface SidebarHeaderProps {
  isCollapsed: boolean;
  onToggle: () => void;
  onHomeClick: () => void;
  showCloseButton?: boolean;
  onClose?: () => void;
}
const SidebarHeader = ({
  isCollapsed,
  onToggle,
  onHomeClick,
  showCloseButton = false,
  onClose
}: SidebarHeaderProps) => {
  return <div className="p-3 border-b border-slate-200/50 flex items-center justify-between">
    {!isCollapsed && <Button variant="ghost" size="sm" onClick={onHomeClick} className="flex items-center hover:bg-slate-50/50 rounded-xl transition-colors p-2">
      <img src="/Logo/sblogo.png" alt="StudiBudi logo" className="h-7 w-auto object-contain" />
    </Button>}

    {showCloseButton && onClose ? <Button variant="ghost" size="sm" onClick={onClose} className="p-2 rounded-xl">
      <X className="w-6 h-6 text-slate-600" />
    </Button> : <Button variant="ghost" size="sm" onClick={onToggle} className="p-2 rounded-xl">
      {isCollapsed ? <PanelLeftOpen className="w-6 h-6 text-slate-600" /> : <PanelLeftClose className="w-6 h-6 text-slate-600" />}
    </Button>}
  </div>;
};
export default SidebarHeader;
